<template>
  <dl class="space-y-6 divide-y divide-light">
    <Disclosure as="div" v-for="item in accordionItems" :key="item.title" class="pt-6" v-slot="{ open }">
      <dt class="text-lg">
        <DisclosureButton class="text-left w-full flex justify-between items-start" :class="{ 'text-primary': open }">
          <span class="h5 uppercase leading-tight">
            {{ item.title }}
          </span>
          <span class="ml-6 h-7 flex items-center">
            <MinusIcon v-if="open" class="h-6 w-6" aria-hidden="true" />
            <PlusIcon v-else class="h-6 w-6" aria-hidden="true" />
          </span>
        </DisclosureButton>
      </dt>
      <DisclosurePanel as="dd" v-html="item.content" class="mt-2 pr-12 text-base text-gray-500">
      </DisclosurePanel>
    </Disclosure>
  </dl>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { PlusIcon, MinusIcon } from '@heroicons/vue/outline'

export default {
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    PlusIcon,
    MinusIcon,
  },

  props: {
      items: {
          type: String,
          default: '[]',
      }, 
  },

  computed: {
    accordionItems() {
      return JSON.parse(this.items)
    }
  },
}
</script>